var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLetzAiError(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 301,
    height: 279,
    viewBox: "0 0 301 279",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M176.607 148.334C232.023 99.1502 281.984 116.854 300.038 131.853C297.779 47.4905 240.949 13.8406 212.816 7.56105C91.2867 -27.123 27.0087 65.7022 22.9757 120.136C18.2975 289.582 178.217 267.686 181.797 266.048C124.846 200.771 172.168 157.551 176.607 148.334Z",
    fill: "#F08B1F"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15900_34030)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.4601 135.566L37.7502 136.293L56.2638 146.714L74.7774 136.293L76.0675 135.566L77.3577 136.293L95.8713 146.714L114.385 136.293L115.675 135.566L116.965 136.293L135.479 146.714L153.992 136.293L156.573 140.924L136.769 152.072L135.479 152.798L134.189 152.072L115.675 141.651L97.1614 152.072L95.8713 152.798L94.5811 152.072L76.0675 141.651L57.554 152.072L56.2638 152.798L54.9737 152.072L36.4601 141.651L17.9465 152.072L16.6564 152.798L15.3662 152.072L-4.4375 140.924L-1.85719 136.293L16.6564 146.714L35.1699 136.293L36.4601 135.566ZM36.4601 167.948L37.7502 168.675L56.2638 179.096L74.7774 168.675L76.0675 167.948L77.3577 168.675L95.8713 179.096L114.385 168.675L115.675 167.948L116.965 168.675L135.479 179.096L153.992 168.675L156.573 173.306L136.769 184.454L135.479 185.18L134.189 184.454L115.675 174.033L97.1614 184.454L95.8713 185.18L94.5811 184.454L76.0675 174.033L57.554 184.454L56.2638 185.18L54.9737 184.454L36.4601 174.033L17.9465 184.454L16.6564 185.18L15.3662 184.454L-4.4375 173.306L-1.85719 168.675L16.6564 179.096L35.1699 168.675L36.4601 167.948ZM37.7502 201.056L36.4601 200.33L35.1699 201.056L16.6564 211.478L-1.85719 201.056L-4.4375 205.688L15.3662 216.836L16.6564 217.562L17.9465 216.836L36.4601 206.414L54.9737 216.836L56.2638 217.562L57.554 216.836L76.0675 206.414L94.5811 216.836L95.8713 217.562L97.1614 216.836L115.675 206.414L134.189 216.836L135.479 217.562L136.769 216.836L156.573 205.688L153.992 201.056L135.479 211.478L116.965 201.056L115.675 200.33L114.385 201.056L95.8713 211.478L77.3577 201.056L76.0675 200.33L74.7774 201.056L56.2638 211.478L37.7502 201.056Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M192.909 144.463C177.183 139.39 173.413 123.516 173.413 123.516C173.951 122.746 174.472 121.978 174.959 121.227L175.468 113.038C167.253 110.767 171.916 100.764 171.916 100.764C168.149 95.2587 165.005 89.3518 162.541 83.1523C157.981 83.5968 153.611 85.2107 149.857 87.8383C152.997 98.3203 158.299 111.262 169.567 128.504C164.719 134.557 156.804 144.127 152.992 149.104L122.6 135.498L115.672 149.826L149.785 167.293C152.141 168.395 154.807 168.641 157.325 167.988C159.843 167.335 162.055 165.825 163.579 163.717L171.045 153.425C174.041 158.016 176.336 161.785 184.651 165.264C193.497 161.284 197.327 156.463 200.644 149.826C197.773 148.502 195.156 146.687 192.909 144.463Z",
    fill: "#FFD0C6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M193.322 206.383L192.09 199.642L220.887 194.328L222.119 201.068L193.322 206.383Z",
    fill: "#6158DB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M218.522 200.703L214.004 195.583L238.333 174.129L242.849 179.25L218.522 200.703Z",
    fill: "#6158DB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M242.923 188.6L245.87 184.131L241.328 180.555L238.938 182.705L242.923 188.6Z",
    fill: "#6158DB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M258.527 194.018L254.712 202.792C253.561 205.465 251.579 207.695 249.059 209.15L268.097 223.994L279.308 210.175L258.527 194.018Z",
    fill: "#6158DB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M238.454 127.14C241.626 127.583 244.847 126.778 247.438 124.894C250.029 123.01 251.788 120.195 252.345 117.04C248.435 115.783 244.313 115.321 240.221 115.682C236.13 116.043 232.153 117.219 228.523 119.142C229.304 121.247 230.639 123.101 232.388 124.508C234.135 125.916 236.232 126.825 238.454 127.14Z",
    fill: "#6158DB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M165.658 122.307L148.07 108.633C145.541 113.993 141.882 118.741 137.344 122.552L159.979 140.406L169.595 128.496L165.658 122.307Z",
    fill: "#141414"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M179.764 141.539L171.07 153.523C171.682 154.647 172.394 155.714 173.196 156.711L179.764 141.539Z",
    fill: "#141414"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M175.32 115.543L178.774 113.104C177.679 113.175 176.581 113.151 175.489 113.031L175.32 115.543Z",
    fill: "#141414"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M198.294 128.13C198.548 126.182 198.106 124.207 197.045 122.554C195.983 120.901 194.374 119.675 192.497 119.094C192.737 118.404 192.811 117.668 192.714 116.944C191.12 105.299 188.703 98.1236 184.717 94.0176C182.011 91.1895 176.479 91.6498 173.193 95.78C169.93 99.9166 170.751 105.373 170.729 105.826C171.06 101.761 172.957 97.9841 176.02 95.2917C176.877 94.5879 177.886 94.0918 178.967 93.8421C178.797 97.5158 181.721 103.337 185.248 101.888C187.607 100.925 187.891 105.194 183.243 105.194C181.987 115.268 182.373 126.812 187.012 136.215L187.761 137.639C190.041 141.792 193.3 145.325 197.256 147.932C199.884 148.07 202.457 147.158 204.413 145.398C206.368 143.637 207.543 141.173 207.681 138.545C207.818 135.918 206.907 133.344 205.147 131.389C203.386 129.435 200.921 128.259 198.294 128.121V128.13Z",
    fill: "#141414"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M173.523 33.0348C172.761 33.0131 172.009 33.2181 171.364 33.6238C170.718 34.0293 170.207 34.6173 169.895 35.3132C169.584 36.0093 169.485 36.7821 169.613 37.5339C169.741 38.2858 170.088 38.9829 170.612 39.5371C171.136 40.0914 171.812 40.4778 172.556 40.6476C173.299 40.8174 174.076 40.7628 174.789 40.4909C175.501 40.2191 176.117 39.7421 176.558 39.1201C177 38.4983 177.247 37.7595 177.268 36.9971C177.296 35.9753 176.918 34.9842 176.215 34.2411C175.513 33.4983 174.545 33.0644 173.523 33.0348Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M171.554 100.251C167.905 94.9169 164.889 89.1769 162.566 83.1465C158.004 83.5891 153.634 85.2056 149.883 87.8388C153.024 98.3233 158.314 111.249 169.593 128.499",
    stroke: "#141414",
    strokeWidth: 2.23266,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M153.743 80.5351C153.065 77.0105 152.806 73.4185 152.969 69.8331C152.897 67.9805 153.025 66.1254 153.351 64.3003C154.241 59.2939 155.461 59.7822 155.864 64.6144C156.849 76.4506 159.679 80.366 160.719 83.4103",
    stroke: "#141414",
    strokeWidth: 2.23266,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M153.143 65.8225C152.333 64.1141 151.283 62.5298 150.026 61.1175C149.645 60.7513 148.754 60.7144 149.857 63.7752C150.093 64.4288 151.038 67.2544 151.331 68.2691C152.009 70.2936 152.558 72.3591 152.974 74.4531",
    stroke: "#141414",
    strokeWidth: 2.23266,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M153.312 77.7088C153.143 80.1008 149.449 76.4016 147.707 75.0028C146.139 73.7439 143.892 72.944 147.054 77.5155C148.928 80.4321 150.346 83.6178 151.258 86.9624",
    stroke: "#141414",
    strokeWidth: 2.23266,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M244.634 191.113L238.934 182.705",
    stroke: "white",
    strokeWidth: 2.23266,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M175.521 112.967C175.521 112.967 175.254 116.314 174.988 121.218C174.457 121.967 173.95 122.716 173.418 123.507",
    stroke: "#141414",
    strokeWidth: 2.23266,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M178.777 113.176L175.332 115.513",
    stroke: "#141414",
    strokeWidth: 2.23266,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M215.206 194.495L195.902 173.211",
    stroke: "white",
    strokeWidth: 2.23266,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M179.738 141.516L173.191 156.687",
    stroke: "#141414",
    strokeWidth: 2.23266,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M229.509 181.884C222.009 169.83 211.118 160.257 198.199 154.367",
    stroke: "white",
    strokeWidth: 2.23266,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M194.093 199.273L184.715 165.24",
    stroke: "white",
    strokeWidth: 2.23266,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M221.539 198.046L222.119 201.067L193.322 206.382L192.09 199.641L214.003 195.607",
    stroke: "white",
    strokeWidth: 2.23266,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M197.235 147.965C199.823 148.034 202.336 147.09 204.238 145.334C206.141 143.578 207.283 141.148 207.421 138.563C207.56 135.978 206.684 133.441 204.98 131.492C203.276 129.543 200.877 128.336 198.297 128.128C198.552 126.18 198.109 124.205 197.049 122.551C195.987 120.898 194.377 119.673 192.5 119.092C193.282 116.824 190.863 102.576 186.508 96.2151C182.421 90.2461 176.447 91.6436 173.172 95.7776C169.898 99.9117 170.73 105.37 170.708 105.823",
    stroke: "#141414",
    strokeWidth: 2.23266,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M242.92 188.601L259.374 163.572C262.513 158.522 262.392 156.927 263.794 153.449C270.366 149.874 285.272 145.67 292.641 144.703C287.229 153.159 274.545 158.159 269.544 168.645L254.686 202.758C253.808 204.779 252.453 206.556 250.738 207.939C249.024 209.321 246.999 210.268 244.839 210.698C242.677 211.128 240.445 211.027 238.332 210.407C236.217 209.785 234.286 208.661 232.701 207.131L222.457 197.251",
    stroke: "white",
    strokeWidth: 2.23266,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M218.518 200.703L214 195.583L238.329 174.129L242.846 179.25L218.518 200.703Z",
    stroke: "white",
    strokeWidth: 2.23266,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M110.164 137.408C112.797 137.142 108.419 132.966 107.699 131.686C106.726 129.95 105.695 127.94 110.236 131.13C113.915 133.452 117.731 135.549 121.663 137.411",
    stroke: "#141414",
    strokeWidth: 2.23266,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M197.961 205.511L199.965 212.711C201.272 217.337 204.332 221.271 208.494 223.678C212.649 226.094 250.604 244.311 250.604 244.311C260.727 250.033 264.857 263.01 272.927 269.002C272.468 261.584 269.279 246.413 266.162 239.627C262.837 238.012 261.218 238.006 256.596 234.7L220.331 209.211L218.255 201.77",
    stroke: "white",
    strokeWidth: 2.23266,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M179.741 141.514C178.366 143.302 170.114 154.72 163.579 163.741C162.053 165.847 159.841 167.355 157.324 168.007C154.807 168.659 152.141 168.414 149.785 167.314L115.672 149.85L122.581 135.523L152.972 149.101",
    stroke: "#141414",
    strokeWidth: 2.23266,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M192.908 144.463C195.171 146.679 197.788 148.502 200.651 149.856C197.447 157.231 191.964 162.006 184.67 165.288C176.332 161.798 174.049 158.064 171.039 153.453",
    stroke: "#141414",
    strokeWidth: 2.23266,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M236.928 175.339C221.961 155.278 206.101 152.102 200.652 149.855",
    stroke: "white",
    strokeWidth: 2.23266,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M173.414 123.517C173.414 123.517 177.183 139.389 192.911 144.463C190.486 142.072 188.484 139.286 186.991 136.224C182.341 126.833 181.966 115.278 183.222 105.204H183.85C187.665 104.987 187.594 100.925 185.228 101.898C181.699 103.344 178.778 97.5247 178.947 93.8535C177.867 94.1048 176.859 94.6002 175.999 95.3019C174.213 96.8664 172.811 98.8223 171.906 101.017C170.999 103.212 170.612 105.587 170.774 107.956C171.224 111.027 173.339 113.481 178.778 113.181",
    stroke: "#141414",
    strokeWidth: 2.23266,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M173.41 123.514C171.139 126.947 153.43 147.939 151.062 151.781",
    stroke: "#141414",
    strokeWidth: 2.23266,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M101.151 140.16C99.9908 140.305 97.6002 140.79 96.8982 140.933C93.7103 141.589 94.121 142.431 94.6284 142.48C96.6808 142.674 100.015 142.65 101.924 142.89C104.992 143.278 110.912 143.833 113.231 145.21",
    stroke: "#141414",
    strokeWidth: 2.23266,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M101.751 142.867C101.243 143.06 100.785 143.23 100.567 143.326C97.5232 144.486 98.0802 145.265 98.5863 145.234C100.641 145.113 103.927 144.51 105.859 144.436C108.182 144.393 110.504 144.571 112.793 144.968",
    stroke: "#141414",
    strokeWidth: 2.23266,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M220.144 73.4574C220.106 74.0787 219.885 74.6748 219.507 75.1701C219.131 75.6655 218.616 76.0381 218.027 76.2406C217.438 76.443 216.802 76.4664 216.201 76.3077C215.598 76.149 215.058 75.8155 214.645 75.349C214.233 74.8826 213.968 74.3044 213.884 73.6876C213.8 73.0708 213.902 72.4428 214.175 71.8835C214.447 71.3241 214.881 70.8583 215.419 70.5449C215.957 70.2316 216.575 70.0849 217.197 70.1231C218.028 70.1768 218.805 70.5575 219.358 71.1823C219.91 71.807 220.193 72.6249 220.144 73.4574Z",
    stroke: "white",
    strokeWidth: 2.23266,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M273.528 149.464C273.995 144.949 273.456 140.386 271.949 136.104C270.443 131.821 268.007 127.925 264.818 124.696C261.627 121.466 257.761 118.983 253.498 117.424C249.234 115.865 244.678 115.27 240.157 115.681C235.636 116.092 231.262 117.498 227.349 119.799C223.436 122.101 220.082 125.24 217.525 128.992C214.969 132.743 213.276 137.014 212.565 141.498C211.856 145.982 212.148 150.567 213.42 154.925",
    stroke: "white",
    strokeWidth: 2.23266,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M240.84 176.976C244.297 177.222 247.77 176.87 251.108 175.938",
    stroke: "white",
    strokeWidth: 2.23266,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M241.876 102.618C239.454 102.284 236.988 102.674 234.787 103.741C232.587 104.808 230.753 106.503 229.516 108.612C228.279 110.721 227.695 113.149 227.837 115.59C227.981 118.031 228.843 120.375 230.318 122.325C231.792 124.276 233.812 125.746 236.121 126.549C238.43 127.352 240.926 127.453 243.293 126.838C245.659 126.223 247.789 124.921 249.417 123.096C251.043 121.27 252.092 119.003 252.431 116.582C252.88 113.331 252.021 110.035 250.043 107.417C248.064 104.799 245.126 103.073 241.876 102.618Z",
    stroke: "#6158DB",
    strokeWidth: 2.23266,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M150.533 65.7504C147.452 57.8915 142.488 50.9099 136.076 45.4197C129.664 39.9295 122.002 36.0987 113.763 34.2644C105.523 32.4301 96.9592 32.6483 88.824 34.9C80.6886 37.1516 73.2313 41.3677 67.1075 47.1774C60.9839 52.9871 56.3814 60.2124 53.7051 68.2181C51.0287 76.2237 50.3604 84.7642 51.7589 93.0888C53.1574 101.413 56.5798 109.267 61.7253 115.958C66.8708 122.65 73.5815 127.974 81.2676 131.464C90.4252 135.549 100.562 136.924 110.477 135.427",
    stroke: "#141414",
    strokeWidth: 2.23266,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M152.706 96.2402C151.141 103.009 148.218 109.389 144.116 114.996C140.013 120.602 134.815 125.317 128.837 128.856C124.705 131.295 120.247 133.134 115.598 134.317",
    stroke: "#141414",
    strokeWidth: 2.23266,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M119.029 47.6326C112.351 44.6539 104.989 43.549 97.7309 44.4365C90.4732 45.3239 83.5939 48.1702 77.8306 52.6701C72.0675 57.17 67.6379 63.1538 65.0168 69.9796C62.3957 76.8056 61.6821 84.2162 62.9524 91.4168C64.2228 98.6175 67.4291 105.337 72.2277 110.854C77.0263 116.37 83.236 120.477 90.1912 122.733C97.1462 124.99 104.584 125.31 111.708 123.66C118.831 122.011 125.371 118.453 130.626 113.369C150.864 93.8893 145.341 59.3544 119.029 47.6326Z",
    stroke: "#141414",
    strokeWidth: 2.23266,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M176.285 176.4L165.848 177.728",
    stroke: "#141414",
    strokeWidth: 2.23266,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M171.719 182.296L170.391 171.836",
    stroke: "#141414",
    strokeWidth: 2.23266,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M116.854 147.384C113.47 145.15 109.888 143.235 106.152 141.662C103.152 140.565 100.038 139.812 96.8686 139.415C92.2056 138.843 91.6728 137.588 96.7478 136.902C98.6152 136.676 100.497 136.595 102.377 136.661C105.942 136.707 109.491 137.144 112.96 137.965",
    stroke: "#141414",
    strokeWidth: 2.23266,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M195.907 196.519L186.824 165.896C191.547 166.727 196.448 161.485 198.308 158.76C208.169 162.652 220.28 175.65 225.103 181.662L215.306 190.356C209.878 184.538 198.775 172.683 197.789 171.8C196.556 170.697 195.453 170.827 194.35 171.476C193.247 172.125 193.637 174.006 193.831 174.396C193.987 174.707 204.839 187.544 210.245 193.924L195.907 196.519Z",
    fill: "#6158DB"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15900_34030"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150.574,
    height: 140.138,
    fill: "white",
    transform: "translate(0.0351562 98.2949)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLetzAiError);
export default __webpack_public_path__ + "static/media/letzAiError.303cecd0a1067a999b438f5a1252089a.svg";
export { ForwardRef as ReactComponent };